const historyLocationsActions = {
  LOCATION_ADD: 'LOCATION_ADD'
};
export default historyLocationsActions;
